module.exports = {"370105001":"无影山街道","370105003":"天桥东街街道","370105004":"北村街道","370105005":"南村街道","370105006":"堤口路街道","370105007":"北坦街道","370105009":"制锦市街道","370105010":"宝华街道","370105011":"官扎营街道","370105012":"纬北路街道","370105013":"药山街道","370105014":"北园街道","370105015":"泺口街道","370105016":"桑梓店街道","370105017":"大桥街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370105.json
// module id = 1354
// module chunks = 0